<template>
  <section>
    <div v-if="!loading">
      <b-overlay :show="redirect" rounded="sm">
        <button
          :disabled="checkDisabled"
          v-on:click="loginSubmit"
          class="btn btn-fill mt-2 btn-block btn-primary"
        >
          {{ $t("LOGIN") }}
        </button>
      </b-overlay>
    </div>
    <div class="p-4 text-center" v-if="loading && identifier" :key="identifier">
      <div v-if="hintMessage == 'OUTSTANDING_TRANSACTION'">
        <div v-if="!showOnThisDevice">
          1. {{ $t("NETID_ACCESS.OUTSTANDING_TRANSACTION") }}.<br />
          2. {{ $t("NETID_ACCESS.USER_SIGN") }}.<br />

          <qrcode-vue
            class="qrcode mt-2 mb-4"
            v-if="identifier != ''"
            :value="startThisDevice"
            :key="identifier"
            size="200" margin="2"
            level="H"
          ></qrcode-vue>

          
          <a variant="primary" :href="startThisDevice">{{ $t("SAME_DEVICE") }}</a>

        </div>
        <div class="mt-2 mb-2" v-if="showOnThisDevice">
           <a variant="primary" class="btn btn-primary btn-fill text-white" :href="startThisDevice">{{ $t("SAME_DEVICE") }}</a>
          <br />
          <br />
          <a href="#" @click.prevent="otherDevice"> {{ $t("OTHER_DEVICE") }}</a>
        </div>
      </div>

      <div v-if="hintMessage != 'OUTSTANDING_TRANSACTION'">
        <h5>{{ statusMessage }}</h5>
      </div>

      <button v-on:click="cancelSubmit" class="mt-4 btn btn-secondary">
        {{ $t("CANCEL") }}
      </button>
    </div>
  </section>
</template>
<script>
import mobileDetect from "mobile-device-detect";
import QrcodeVue from "qrcode.vue";
export default {
  props: ["loginInfo"],
  components: {
    QrcodeVue
  },
  data() {
    return {
      redirect: false,
      device: mobileDetect,
      loading: true,
      identifier: "",
      auth_uuid: "",
      statusMessage: "",
      timer: null,
      hintMessage: "",
      errorMessage: "",
      showOnThisDevice: false
    };
  },
  methods: {
    otherDevice: function() {
      this.showOnThisDevice = false;
    },
    reset: function() {
      clearTimeout(this.timer);
      this.loading = false;
      this.identifier = "";
      this.showOnThisDevice = !this.device.isMobile;
      this.$emit("loading", false);
    },
    cancelSubmit: function() {
      let self = this;
      self.reset();
      this.$http
        .get(this.user.hostname + "/authenticate/cancel/" + this.auth_uuid);
    },
    loginSubmit: async function() {
      this.loading = true;
      let self = this;
      self.$emit("loading", true);
      this.$http
        .post(this.user.hostname + "/authenticate", {
          email: this.loginInfo.email,
          auth_type: this.loginInfo.auth_type,
          auth_method: this.loginInfo.auth_method,
          client: "web"
        })
        .then(function(result) {
          if(result.data.redirect == 1)
          {
            self.loading = false;
            self.redirect = true;
            window.location.href = result.data.request_url;
          }else{
            self.statusMessage = "";
            self.auth_uuid = result.data.auth_uuid;
            self.identifier = result.data.identifier;
            self.hintMessage = "OUTSTANDING_TRANSACTION";
            self.timer = setTimeout(self.checkStatus, 1000);
          }
        })
        .catch(function(error) {
          self.reset();
          if (error.response != undefined) {
            self.$noty.error(self.$t("ERROR.CANNOT_LOGIN"));
          }
        });
    },
    checkStatus: function() {
      let self = this;
      if (this.identifier != "") {
        this.loading = true;
        this.$http
          .get(this.user.hostname + "//authenticate/status/" + this.auth_uuid)
          .then(function(result) {
            if (result.status == 200) {
              clearTimeout(self.timer);
              self.verifyAuthentication();
            }
            if (result.status == 202) {
              if(result.data == "TIMEOUT"){                
                self.$noty.error(self.$t("ERROR.CANNOT_LOGIN"));
                self.reset();  
              }else{
                self.hintMessage = result.data;
                self.statusMessage = self.$t("NETID_ACCESS." + result.data);
                self.timer = setTimeout(self.checkStatus, 1000);
              }
            }
          })
          .catch(function() {
            if(self.identifier != "")
            {
              self.$noty.error(self.$t("ERROR.CANNOT_LOGIN"));
            }
            self.reset();
          });
      }
    },
    verifyAuthentication: function() {
      let self = this;
      this.$http
        .get(this.user.hostname + "/authenticate/result/" + this.auth_uuid)
        .then(function(result) {
          self.$emit("authenticated", result.data.token);
        })
        .catch(function() {
          self.reset();
          self.$noty.error(self.$t("ERROR.CANNOT_LOGIN"));
        });
    },
  },
  computed: {
    startThisDevice() {
      return "netid://?autostarttoken=" + this.identifier + "&redirect=NULL"
    },
    checkDisabled: function() {
      return this.loginInfo.email == "";
    },
  },
  mounted: function() {
    this.loading = false;
    this.showOnThisDevice = !this.device.isMobile;
  },
};
</script>
<style></style>